








import { Vue, Component } from 'vue-property-decorator'

const config = {
  name: 'icon-text-size',
  components: {}
}

@Component(config)
export default class IconTextSize extends Vue {}
